import React from "react"

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Capa_1"
      data-name="Capa 1"
      viewBox="0 0 512 512"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-1{fill:#283f71}"}</style>
      </defs>
      <title>{"icons"}</title>
      <path
        className="prefix__cls-1"
        d="M256.23,510.69A254.91,254.91,0,0,1,76,75.52,254.92,254.92,0,1,1,436.48,436,253.23,253.23,0,0,1,256.23,510.69Zm0-501.83A246.91,246.91,0,0,0,81.63,430.37,246.92,246.92,0,1,0,430.83,81.18,245.31,245.31,0,0,0,256.23,8.86Z"
      />
      <path
        className="prefix__cls-1"
        d="M290.66,324.75H221.8l-1.18-1.2C173.37,275.07,155.74,218.73,149.27,180c-7-42-2.92-72.07-2.74-73.33l.49-3.44H365.44l.48,3.44c.18,1.26,4.28,31.37-2.73,73.33-6.47,38.74-24.1,95.08-71.35,143.56Zm-65.48-8h62.1C332.21,270,349.07,216,355.3,178.67c5.47-32.76,3.92-58.48,3.08-67.45H154.08A272.52,272.52,0,0,0,157.2,179C163.46,216.16,180.33,270.12,225.18,316.75Z"
      />
      <path
        className="prefix__cls-1"
        d="M362.14,487.31a4,4,0,0,1-3.63-2.31,44.5,44.5,0,0,0-40.17-25.56H194.11A44.49,44.49,0,0,0,154,485a4,4,0,0,1-7.25-3.38,52.52,52.52,0,0,1,47.41-30.18H318.34a52.52,52.52,0,0,1,47.42,30.18,4,4,0,0,1-1.93,5.31A3.92,3.92,0,0,1,362.14,487.31Z"
      />
      <path
        className="prefix__cls-1"
        d="M326.57,459.44H185.89l-.33-3.64A54.28,54.28,0,0,1,194,424a38.93,38.93,0,0,1,11.55-11.66l1.32-.84c10.11-6.45,25.39-16.2,25.39-32.6,0-22.75-11.38-32.77-11.49-32.87l-1.48-1.27,1.22-28H292l1.2,28L291.73,346a30.49,30.49,0,0,0-5.74,7.89c-2.62,4.9-5.75,13.21-5.75,25,0,16.4,15.28,26.14,25.38,32.59l1.33.85A38.93,38.93,0,0,1,318.5,424h0a54.28,54.28,0,0,1,8.4,31.8Zm-133-8H318.94a46.69,46.69,0,0,0-7.14-23.07h0a30.92,30.92,0,0,0-9.17-9.29l-1.31-.84c-10.88-6.94-29.08-18.56-29.08-39.34,0-21.57,9.15-33.56,12.81-37.5l-.72-16.65h-56.2l-.73,16.65c3.66,3.94,12.82,15.93,12.82,37.5,0,20.79-18.21,32.4-29.09,39.34l-1.3.84a30.92,30.92,0,0,0-9.17,9.29A46.66,46.66,0,0,0,193.52,451.44Z"
      />
      <path
        className="prefix__cls-1"
        d="M337.07,255.92a4,4,0,0,1,0-8c24.28,0,82.37-8.88,97.41-91.09a4.51,4.51,0,0,0-1-3.72,4.42,4.42,0,0,0-3.46-1.62H363.12a4,4,0,0,1,0-8H430a12.52,12.52,0,0,1,12.31,14.79c-2.35,12.81-8.64,37.49-24.43,58.66C398.64,242.81,371.44,255.92,337.07,255.92Z"
      />
      <path
        className="prefix__cls-1"
        d="M337.07,255.92a4,4,0,0,1,0-8c24.28,0,82.37-8.88,97.41-91.09a4.51,4.51,0,0,0-1-3.72,4.42,4.42,0,0,0-3.46-1.62H363.12a4,4,0,0,1,0-8H430a12.52,12.52,0,0,1,12.31,14.79c-2.35,12.81-8.64,37.49-24.43,58.66C398.64,242.81,371.44,255.92,337.07,255.92Z"
      />
      <path
        className="prefix__cls-1"
        d="M175.39,255.92c-34.37,0-61.58-13.11-80.85-39-15.79-21.17-22.08-45.85-24.43-58.67a12.51,12.51,0,0,1,12.31-14.78h66.92a4,4,0,1,1,0,8H82.42A4.42,4.42,0,0,0,79,153.11a4.51,4.51,0,0,0-1,3.72c15,82.21,73.13,91.09,97.41,91.09a4,4,0,0,1,0,8Z"
      />
      <path
        className="prefix__cls-1"
        d="M280.43,305a4,4,0,0,1-3-6.69c57.29-63.07,62.37-140.75,61.9-171.22A4,4,0,0,1,343.3,123h.07a4,4,0,0,1,4,3.94,278.33,278.33,0,0,1-9.82,76.93c-10.48,38.19-28.69,71.76-54.15,99.79A4,4,0,0,1,280.43,305Z"
      />
    </svg>
  )
}

export default SvgComponent

